module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/full-crud-example/examples/examples.component.scss
// module id = ./src/app/components/examples/full-crud-example/examples/examples.component.scss
// module chunks = main